import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9c3e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "school-year"
}
const _hoisted_2 = {
  key: 1,
  class: "school-year-unit"
}
const _hoisted_3 = { class: "school-type" }
const _hoisted_4 = { class: "grade-number" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grade-number-unit" }, "年", -1))
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name-unit" }, "組", -1))
const _hoisted_8 = {
  key: 1,
  class: "class-area"
}
const _hoisted_9 = {
  key: 0,
  class: "school-year"
}
const _hoisted_10 = {
  key: 1,
  class: "school-year-unit"
}
const _hoisted_11 = { class: "school-type" }
const _hoisted_12 = { class: "grade-number" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grade-number-unit" }, "年", -1))
const _hoisted_14 = { class: "name" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name-unit" }, "組", -1))
const _hoisted_16 = { class: "in-charge-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TextBalloon = _resolveComponent("TextBalloon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "teacher-class-text-container",
    style: _normalizeStyle(_ctx.styles)
  }, [
    (_ctx.isLink)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "class-area link",
          to: _ctx.linkPath
        }, {
          default: _withCtx(() => [
            (_ctx.showSchoolYear)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.teacherClass.schoolYear), 1))
              : _createCommentVNode("", true),
            (_ctx.showSchoolYear)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "年度"))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.schoolTypeDisplayValue), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.teacherClass.grade.gradeNumber), 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.className), 1),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.showSchoolYear)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.teacherClass.schoolYear), 1))
            : _createCommentVNode("", true),
          (_ctx.showSchoolYear)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "年度"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.schoolTypeDisplayValue), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.teacherClass.grade.gradeNumber), 1),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.className), 1),
          _hoisted_15
        ])),
    _createElementVNode("div", {
      class: "in-charge-type-area",
      onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
    }, [
      _createElementVNode("span", _hoisted_16, "(" + _toDisplayString(_ctx.teacherClass.inChargeType) + ")", 1),
      (_ctx.hovering)
        ? (_openBlock(), _createBlock(_component_TextBalloon, {
            key: 0,
            text: _ctx.inChargeTypeBalloonContent,
            "on-cursor": true
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ], 32)
  ], 4))
}